import React from "react";
import { tono } from "./tonos";

/**
 * Fila de mini KPIs de tendencia del kit de tableros (vivas, nuevas,
 * cerradas, vencidas...). Cada mini puede ser un drill-down.
 * @author Diego Serrano <diego.serrano@repremundo.com.co>
 * @since 2026-09-14
 * @param {Array} items [{clave, etiqueta, valor, tonoxxx, nota, onClick}]
 */
const Tendencx = ({ items = [] }) => (
  <div className="tbl-fila">
    {items.map((item) => {
      const t = tono(item.tonoxxx);
      return (
        <div
          key={item.clave ?? item.etiqueta}
          className={`tbl-card tbl-mini ${item.onClick ? "tbl-kpi clic" : ""}`}
          onClick={item.onClick}
          role={item.onClick ? "button" : undefined}
        >
          <span className="tbl-kicker">{item.etiqueta}</span>
          <span className="tbl-mini-valor" style={{ color: item.tonoxxx ? t.hex : undefined }}>{item.valor}</span>
          {item.nota && <span className="tbl-kpi-nota">{item.nota}</span>}
        </div>
      );
    })}
  </div>
);

export default Tendencx;
